import { hrBaseApi } from "app/services/HrBaseApi";

export const employeeClaimApi = hrBaseApi.injectEndpoints({
  endpoints: (builder) => ({

    /* ========= LIST ========= */

    getEmployeeClaimsApproval: builder.query({
      query: ({ Partner_Id, page }) => ({
        url: `/Felix/Employeeclaimsapproval/`,
        method: "POST",
        body: {
          Partner_Id,
          page,
        },
      }),
      providesTags: ["EmployeeClaims"],
    }),

    /* ========= GET SINGLE CLAIM ========= */

    getEmployeeClaimById: builder.query({
      query: ({ Employeeclaim_Id }) => ({
        url: `/Felix/EmployeeclaimsCRUD/`,
        method: "GET",
        params: {
          Employeeclaim_Id,
        },
      }),
      providesTags: ["EmployeeClaims"],
    }),

    /* ========= FILTER ========= */

    getEmployeeClaimsFilter: builder.mutation({
      query: (payload) => ({
        url: `/Felix/EmployeeclaimsFilter/`,
        method: "POST",
        body: payload,
      }),
    }),

    /* ========= DELETE ========= */

    deleteEmployeeClaim: builder.mutation({
      query: (Employeeclaim_Id) => ({
        url: `/Felix/EmployeeclaimsCRUD/`,
        method: "DELETE",
        params: {
          Employeeclaim_Id,
        },
      }),
      invalidatesTags: ["EmployeeClaims"],
    }),

    /* ========= SEARCH ========= */

    searchEmployeeClaims: builder.query({
      query: ({ search, page }) => ({
        url: `/Felix/EmployeeclaimsSearch/`,
        method: "GET",
        params: {
          search,
          page,
        },
      }),
    }),

  }),
});

export const {
  useGetEmployeeClaimsApprovalQuery,
  useGetEmployeeClaimByIdQuery,
  useGetEmployeeClaimsFilterMutation,
  useDeleteEmployeeClaimMutation,
  useLazySearchEmployeeClaimsQuery,
} = employeeClaimApi;